import { Injectable } from "@angular/core";
import { Quote } from "../app/models/quote.model";
import { QuoteRequest } from "../app/models/offer.request.model";
import { RequestService } from "../app/web/verify-request/request-service";
import { LangResolverService } from "../app/lang-resolver.service";
import { normalizeLang } from "../app/lang.util";

@Injectable({
  providedIn: 'root',
})
export class CustomerAreaService {

  constructor(
    private requestService: RequestService,
    private langResolver: LangResolverService
  ) { }

  newQuotes?: Quote[];
  receivedQuotes?: Quote[];
  waitingForQuote?: Quote[];
  request?: QuoteRequest;
  isIdentityVerified = false;
  isLoading = true;

  async loadCustomerArea(token: string) {
    try {
      this.isLoading = true;
      const [requestResponse, newQuotes, receivedQuotes, waitingQuotes] = await Promise.all([
        this.requestService.getRequest(token),
        this.requestService.getNewQuotes(token),
        this.requestService.getReceivedQuotes(token),
        this.requestService.getWaitingQuotes(token)
      ]);

      this.newQuotes = newQuotes;
      this.receivedQuotes = receivedQuotes;
      this.waitingForQuote = waitingQuotes;
      this.request = requestResponse.request;

      // La pagina è raggiunta da uno short link non modificabile: la lingua non
      // può stare nell'URL, quindi si parte da quella del lead (la stessa in cui
      // ha ricevuto email/SMS). Un ?lang esplicito ha comunque la precedenza.
      // Unico punto di aggancio per entrambi i chiamanti: RouteResolver (primo
      // accesso) e OtpComponent.goToMyQuotes() (post-verifica OTP).
      this.langResolver.setContextLang(normalizeLang(this.request?.lead?.language));

      setTimeout(() => {
        this.isIdentityVerified = true;
        this.isLoading = false;
      }, 10);

    } catch (error) {
      this.isIdentityVerified = false;
      this.isLoading = false;
      console.error('Error loading customer area data:', error);
      throw error;
    }

  }

  clearData(): void {
    this.newQuotes = undefined;
    this.receivedQuotes = undefined;
    this.waitingForQuote = undefined;
    this.request = undefined;
  }

}
